export default __webpack_public_path__ + "static/media/profilepic.55da6653.jpg";